import { css } from "@emotion/react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Button } from "../Button";
import { Typography } from "../Typography";
import { useHistory, useNavigate } from "./ScreenProvider";

export interface ScreenLayoutProps {
  children: React.ReactNode;
  title: string;
  onPrev?: () => void;
  onNext?: () => void;
}

export const ScreenLayout = ({
  children,
  title,
  onNext,
}: ScreenLayoutProps) => {
  const { onGoBack } = useNavigate();
  const history = useHistory();
  return (
    <div
      css={css`
        display: grid;
        gap: 48px;
      `}
    >
      <div
        css={css`
          display: grid;
          grid-template-columns: 1fr auto 1fr;
          align-items: center;
          min-height: 42px;
        `}
      >
        <div>
          {history.length > 1 ? (
            <Button
              onClick={onGoBack}
              type="button"
              icon={<ArrowBackIosNewIcon />}
            >
              前に戻る
            </Button>
          ) : null}
        </div>
        <Typography variant="h2">{title}</Typography>
        <div
          css={css`
            display: flex;
            justify-content: flex-end;
          `}
        >
          {onNext && (
            <Button
              onClick={onNext}
              type="button"
              endIcon={<ArrowForwardIosIcon />}
            >
              次へ進む
            </Button>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};
